import { Stack } from "@mui/material";
import { useContext } from "react";

import ThemeBtn from "../../../Common/ThemeBtn";
import ThemeContext from "../../../context";
import Context from "../../context";
import useGetTransferPositions from "../../hooks/useGetTransferPositions";

// ----------------------------------------------------------------------

export const PressAllBtn = () => {
	const { actions } = useContext(Context);
	const { actions: themeActions } = useContext(ThemeContext);
	const { positions } = useGetTransferPositions();

	const onClickAll = () => {
		actions.onChangeSelectedPositions(
			positions
				.filter((i) => i.transferTaxExempt || i.transferTaxExempt === null)
				.map((i) => ({ id: i.positionId, shares: undefined }))
		);
		themeActions.setStep(5);
	};

	return (
		<Stack flexDirection={"row"} alignItems={"flex-end"} justifyContent={"flex-end"}>
			<ThemeBtn variant='text' sx={{ minWidth: 120 }} onClick={onClickAll} title='Traspasar todo' />
		</Stack>
	);
};

export default PressAllBtn;
